import { UsedBonusReportTranslations } from ".";

export const USED_BONUS_REPORT_ES_MX: UsedBonusReportTranslations = {
	usedBonus: "Bonos Utilizados",
	columns: {
		client: "Cliente",
		givenAt: "Concedido en",
		consumedAt: "Utilizado en",
		reason: "Razón",
		spentValueInBonus: "Valor del Pago en Bonos",
		total: "Total",
	},
};
